import { render } from "./SubMenuCard.vue?vue&type=template&id=5c27d76a"
import script from "./SubMenuCard.vue?vue&type=script&lang=js"
export * from "./SubMenuCard.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\takht-jamshid\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__